@if(!actions?.length){
    <tilby-dialog-toolbar color="primary" class="sm:tw-p-4 tw-justify-between" title="APPLICATION.PRINTER_ERROR_FISCAL.TITLE" [hideConfirm]="true"/>
}
<tilby-dialog-content [ngClass]="!actions?.length ? 'tw-pt-0' : ''">
    <div class="printer-error-modal-text">{{error}}</div>
</tilby-dialog-content>
@if(actions?.length){
    <tilby-dialog-action-buttons [buttons]="actionButtons"/>
}
